import React from 'react'

import { Box, Display, FlexDirection } from '@gousto-internal/citrus-react'

import { LoadingSkeleton } from '../Search/LoadingSkeleton/LoadingSkeleton'

export const SidesSkeleton = () => (
  <>
    {Array.from({ length: 5 }, (_, index) => index).map((value) => (
      <Box display={Display.Flex} key={value} paddingBottom={1}>
        <Box flexShrink={0} paddingRight={4}>
          <LoadingSkeleton style={{ height: '120px', width: '120px' }} />
        </Box>
        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          paddingRight={12}
          width="100%"
        >
          <LoadingSkeleton style={{ height: '24px', marginBottom: '4px', width: '100%' }} />
          <LoadingSkeleton style={{ height: '24px', marginBottom: '4px', width: '30%' }} />
          <LoadingSkeleton style={{ height: '24px', width: '50%' }} />
        </Box>
        <Box flexShrink={0}>
          <LoadingSkeleton style={{ height: '44px', width: '44px' }} />
        </Box>
      </Box>
    ))}
  </>
)
